import { SET_DRAWER_STATE } from '../actions';

export default function (state={ open: false }, action) {
    switch(action.type) {
        case SET_DRAWER_STATE:
            return {
                ...state,
                open: action.payload
            };
    }
    return state;

}


// WEBPACK FOOTER //
// ./src/reducers/responsiveDrawer.js